var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEditBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 9.89167V11.9183C0 12.105 0.146667 12.2517 0.333333 12.2517H2.36C2.44667 12.2517 2.53333 12.2183 2.59333 12.1517L9.87333 4.87833L7.37333 2.37833L0.1 9.65167C0.0333334 9.71833 0 9.79833 0 9.89167ZM11.8067 2.945C12.0667 2.685 12.0667 2.265 11.8067 2.005L10.2467 0.445C9.98667 0.185 9.56667 0.185 9.30667 0.445L8.08667 1.665L10.5867 4.165L11.8067 2.945Z",
    fill: "#0B0C0C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEditBlack);
export default __webpack_public_path__ + "static/media/icon-edit-black.a328f25e15433407b721db5f96754dd8.svg";
export { ForwardRef as ReactComponent };